import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import { searchApi } from "./api";
import { IMainGift } from "entities/MainGift/types";
import MainGift from "entities/MainGift";
import useDebounce from "shared/hooks/useDebounce";

const SearchContent: React.FC = () => {
  const [value, setValue] = useState("");
  const [giftsList, setGiftsList] = useState<IMainGift[]>([]);
  const [loading, setLoading] = useState(true);
  const debouncedValue = useDebounce(value, 1000);

  useEffect(() => {
    searchApi(debouncedValue)
      .then((res) => setGiftsList(res))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);

    searchApi(debouncedValue)
      .then((res) => setGiftsList(res))
      .finally(() => setLoading(false));
  }, [debouncedValue]);

  return (
    <section className={s.content}>
      <h1>Поиск</h1>

      <div className={s.wrap}>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Введите слово.."
        />
      </div>

      <ul className={s.list}>
        {loading ? (
          <li className={s.title}>Загрузка...</li>
        ) : giftsList.length ? (
          giftsList.map((item, key) => <MainGift {...item} key={key} />)
        ) : (
          <li className={s.title}>Ничего не найдено</li>
        )}
      </ul>
    </section>
  );
};

export default SearchContent;
